import { Eyebrow, Reveal } from "../components/Shared";
import { CLIENTS } from "../data/site";

const ClientsSection = () => (
  <section className="relative bg-white py-24 sm:py-32" data-testid="clients-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <div>
          <Reveal>
            <Eyebrow>06 — Our Clients</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
              Trusted by Industry Leaders.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-md text-base leading-relaxed text-slate">
            Their continued trust reflects our commitment to reliability, consistency and quality.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CLIENTS.map((client, i) => (
          <Reveal key={client} delay={(i % 3) * 0.08} className="h-full">
            <div
              className="card group flex h-full min-h-[150px] flex-col justify-between bg-canvas p-8 transition-[border-color,background-color,box-shadow] duration-300 hover:border-brand/30 hover:bg-white hover:shadow-[0_12px_32px_-16px_rgba(23,78,166,0.25)]"
              data-testid={`client-card-${client.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <span className="text-[11px] font-semibold tracking-[0.18em] text-slate">{String(i + 1).padStart(2, "0")}</span>
              <span className="mt-6 font-display text-lg font-bold uppercase tracking-[0.06em] text-navy/70 transition-colors duration-300 group-hover:text-brand sm:text-xl">
                {client}
              </span>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.2} className="h-full">
          <div className="flex h-full min-h-[150px] flex-col justify-between rounded-2xl bg-brand p-8 shadow-sm">
            <span className="text-[11px] font-semibold tracking-[0.18em] text-white/60">EPG</span>
            <span className="mt-6 font-display text-lg font-bold tracking-tight text-white sm:text-xl">
              Your project could be next.
            </span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ClientsSection;
